exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calendar-spinner[data-v-68395425]{display:flex;justify-content:center;align-content:center;margin:auto;height:400px}.calendar-head h2[data-v-68395425]{margin:0}.calendar-button[data-v-68395425]{font-size:40px}.calendar-button[data-v-68395425]:hover{cursor:pointer;color:#999}.inactive-month[data-v-68395425]{color:#a9a9a9}table[data-v-68395425]{table-layout:fixed}th[data-v-68395425]{font-size:20px;text-align:center}.no-padding[data-v-68395425]{padding:0}", ""]);

// exports
